export default {
  COLLAPSED_TEXT: 'collapsed-text',
  ELEMENT: 'element',
  TEXT: 'text',
};
